import React, { PropTypes } from 'react';
import validate from 'validate.js';
import TextField from 'material-ui/TextField';

const InputField = ({
    field_name,
    value,
    type,
    className,
    onChange,
    label,
    errors,
    autoComplete = 'on'
  }) => {

  let fieldValue = null;

  return(
    <div className={`${className}`}>
      <TextField
        error={(errors && errors.length)}
        id="name"
        label={label}
        value={value}
        margin="normal"
        onChange={onChange}
        name={field_name}
        style={{width: '100%'}}
        helperText={(errors || [])[0]}
        type={type}
        autoComplete={autoComplete}
      />
    </div>
  )
}

InputField.propTypes = {
  field_name: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  errors: PropTypes.oneOfType([
    PropTypes.array,
    null
  ]),
  autoComplete: PropTypes.string
}

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField/InputField.jsx